import './style/index.js';

import _Affix from './Affix';

export type { AffixProps, AffixRef } from './Affix';
export * from './type';

export const Affix = _Affix;
export default Affix;
